import { defineMessages } from "react-intl";

export default defineMessages({
    forbidden: {
        id: "security.securedComponent.forbidden",
        defaultMessage: "Forbidden",
    },
});
